import { render, staticRenderFns } from "./GSheetConfig.vue?vue&type=template&id=067be09b&"
import script from "./GSheetConfig.vue?vue&type=script&lang=js&"
export * from "./GSheetConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067be09b')) {
      api.createRecord('067be09b', component.options)
    } else {
      api.reload('067be09b', component.options)
    }
    module.hot.accept("./GSheetConfig.vue?vue&type=template&id=067be09b&", function () {
      api.rerender('067be09b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/components/GSheetConfig.vue"
export default component.exports